import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "onboarding-wrap" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h6", null, "This is your daily sync ⚡", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Daily syncs is all about increasing transparency with your team by sharing what you are working on. Effective teams should sync each work day!", -1)
const _hoisted_4 = { class: "button-container" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Next ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Skip tour ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h6", null, "What does your workday look like? 🏢", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Let your team mates know about your mood, work times and location for the day.", -1)
const _hoisted_9 = { class: "button-container" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Next ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Skip tour ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h6", null, "It's a simple task list ✅", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Create new tasks by typing and pressing enter. You can re-organise the list by dragging tasks by the drag handle, and complete items by simply checking them. "),
  /*#__PURE__*/_createElementVNode("b", null, "Protip:"),
  /*#__PURE__*/_createTextVNode(" If you have Jira integration enabled, you can link work items by typing "),
  /*#__PURE__*/_createElementVNode("span", null, "/jira")
], -1)
const _hoisted_14 = { class: "button-container" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Next ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Skip tour ")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h6", null, "Add statuses to your items 💬", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "From the settings dropdown you can add a status to your item. It's super handy if you are seeking feedback, want to discuss an item or want to let the team know that the item is being blocked.", -1)
const _hoisted_19 = { class: "button-container" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Next ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Skip tour ")
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h6", null, "Inform your team 🎉", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, "You can use the team talk section to inform the team about something, or even better, post a cheeky picture of your cat sleeping on your keyboard!", -1)
const _hoisted_24 = { class: "button-container" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Next ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Skip tour ")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h6", null, "Make it live! 🚀", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", null, "Once posted, the daily sync will be available for your team. After that, you can have a look, discuss and react on your teams syncs by just scrolling down the page. The latest updates float to the top. Remember, you can updating your list as the day goes through.", -1)
const _hoisted_29 = { class: "button-container" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Finish ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["step step--1 step--arrow-left", { 'active': _ctx.onboardingStep === 1 && _ctx.showOnboarding }])
    }, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_AppButton, {
          size: 'small',
          theme: 'primary',
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setOnboardingStep(2)))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_AppButton, {
          size: 'small',
          theme: 'secondary',
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideOnboarding()))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["step step--2 step--arrow-right", { 'active': _ctx.onboardingStep === 2 && _ctx.showOnboarding }])
    }, [
      _hoisted_7,
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_AppButton, {
          size: 'small',
          theme: 'primary',
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setOnboardingStep(3)))
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }),
        _createVNode(_component_AppButton, {
          size: 'small',
          theme: 'secondary',
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hideOnboarding()))
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        })
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["step step--3 step--arrow-left", { 'active': _ctx.onboardingStep === 3 && _ctx.showOnboarding }])
    }, [
      _hoisted_12,
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_AppButton, {
          size: 'small',
          theme: 'primary',
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setOnboardingStep(4)))
        }, {
          default: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        }),
        _createVNode(_component_AppButton, {
          size: 'small',
          theme: 'secondary',
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hideOnboarding()))
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        })
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["step step--4 step--arrow-right", { 'active': _ctx.onboardingStep === 4 && _ctx.showOnboarding }])
    }, [
      _hoisted_17,
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_AppButton, {
          size: 'small',
          theme: 'primary',
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setOnboardingStep(5)))
        }, {
          default: _withCtx(() => [
            _hoisted_20
          ]),
          _: 1
        }),
        _createVNode(_component_AppButton, {
          size: 'small',
          theme: 'secondary',
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.hideOnboarding()))
        }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        })
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["step step--5 step--arrow-left", { 'active': _ctx.onboardingStep === 5 && _ctx.showOnboarding }])
    }, [
      _hoisted_22,
      _hoisted_23,
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_AppButton, {
          size: 'small',
          theme: 'primary',
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setOnboardingStep(6)))
        }, {
          default: _withCtx(() => [
            _hoisted_25
          ]),
          _: 1
        }),
        _createVNode(_component_AppButton, {
          size: 'small',
          theme: 'secondary',
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.hideOnboarding()))
        }, {
          default: _withCtx(() => [
            _hoisted_26
          ]),
          _: 1
        })
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["step step--6 step--arrow-bottom", { 'active': _ctx.onboardingStep === 6 && _ctx.showOnboarding }])
    }, [
      _hoisted_27,
      _hoisted_28,
      _createElementVNode("div", _hoisted_29, [
        _createVNode(_component_AppButton, {
          size: 'small',
          theme: 'primary',
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.hideOnboarding()))
        }, {
          default: _withCtx(() => [
            _hoisted_30
          ]),
          _: 1
        })
      ])
    ], 2)
  ]))
}